module.exports = __webpack_public_path__ + "assets/images/frame-tl.050d7cfd52028aff336df1c5443ea5d2.png";